import { render, staticRenderFns } from "./LearningDetails.vue?vue&type=template&id=c42a053a&scoped=true"
import script from "./LearningDetails.vue?vue&type=script&lang=js"
export * from "./LearningDetails.vue?vue&type=script&lang=js"
import style0 from "./LearningDetails.vue?vue&type=style&index=0&id=c42a053a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42a053a",
  null
  
)

export default component.exports